import { render, staticRenderFns } from "./serviceTimeDepartment.vue?vue&type=template&id=3568fab8&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./serviceTimeDepartment.vue?vue&type=style&index=0&id=3568fab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3568fab8",
  null
  
)

export default component.exports